import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { Provider, useSelector } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ruRU, enUS, ukUA } from '@mui/material/locale';
import { useTranslation } from 'react-i18next';
import store from './storeRedux';

import Auth from './pages/Auth/Auth';
import Requests from './pages/Requests/Requests';
import Requisites from './pages/Requisites/Requisites';
import Penalties from './pages/Penalties/Penalties';
import AddBalance from './pages/AddBalance/AddBalance';
import Settings from './pages/Settings/Settings';
import ChartsOp from './pages/ChartsOp/ChartsOp';
import Payouts from './pages/Payouts/Payouts';
import NewsWall from './pages/NewsWall/NewsWall';
import MobileEvents from './pages/MobileEvents/MobileEvents';
import Regulation from './pages/Regulation/Regulation';

// Teamlead pages
import TeamMembers from './pages/TeamMembers/TeamMembers';
import CreateTrader from './pages/CreateTrader/CreateTrader';
import TeamleadWithdrawals from './pages/TeamleadWithdrawals/TeamleadWithdrawals';
import OperatorDeposits from './pages/OperatorDeposits/OperatorDeposits';
import TeamStats from './pages/TeamStats/TeamStats';
import BotSetup from './pages/BotSetup/BotSetup';
import TraderDetail from './pages/TraderDetail/TraderDetail';

import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import Layout from './components/Layout/Layout';
import useCheckForUpdates from './hooks/useCheckForUpdates';
import {AnimatedBackground} from "animated-backgrounds";

const MUI_LOCALES = { ru: ruRU, en: enUS, uk: ukUA, kz: ruRU };

function AppContent() {
  const { i18n } = useTranslation();
  const client_background_animation = useSelector((state) => state.CLIENT_BACKGROUND_ANIMATION);
  const client_blend_mode = useSelector((state) => state.CLIENT_BLEND_MODE);

  const muiLocale = MUI_LOCALES[i18n.language] || ruRU;
  const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    muiLocale,
  );

  return (
    <ThemeProvider theme={theme}>
      <div className="App assistant-400">
          <AnimatedBackground animationName={client_background_animation} vblendMode={client_blend_mode}/>
        <BrowserRouter>
            <Routes>
              {/* Доступные всем */}
              <Route path="/auth" element={<Auth />} />

              {/* Авторизованные маршруты с Layout */}
              <Route element={
                <PrivateRoute allowedRoles={['operator', 'teamlead']}>
                  <Layout />
                </PrivateRoute>
              }>
                {/* Общие для operator и teamlead */}
                <Route path="/" element={<Requests />} />
                <Route path="/requisites" element={<Requisites />} />
                <Route path="/penalties" element={<Penalties />} />
                <Route path="/addbalance" element={<AddBalance />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/chartsop" element={<ChartsOp />} />
                <Route path="/payouts" element={<Payouts />} />
                <Route path="/news" element={<NewsWall />} />
                <Route path="/events" element={<MobileEvents />} />
                <Route path="/regulation" element={<Regulation />} />

                {/* Только для teamlead */}
                <Route path="/team" element={<TeamMembers />} />
                <Route path="/team/:id" element={<TraderDetail />} />
                <Route path="/team/create" element={<CreateTrader />} />
                <Route path="/withdrawals" element={<TeamleadWithdrawals />} />
                <Route path="/deposits" element={<OperatorDeposits />} />
                <Route path="/team-stats" element={<TeamStats />} />
                <Route path="/bot-setup" element={<BotSetup />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </div>
      </ThemeProvider>
  );
}

function App() {
  useCheckForUpdates();
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
